<template>
	<div class="bg-light min-vh-100 p-4">
		<div class="container">
			<div class="card shadow-sm border">
				<div class="card-body">
					<!-- Evaluation Details Section -->
					<div
						v-if="selectedClientQuote && selectedClientQuote.length"
						class="border-bottom pb-4 mb-4"
					>
						<h2 class="h4 fw-bold mb-4">Quotation Details</h2>
						<div class="row g-3">
							<div class="col-md-6">
								<label class="form-label fw-semibold"
									>Created Date</label
								>
								<p class="text-sm">
									{{ selectedClientQuote[0].createdAt }}
								</p>
							</div>
							<div class="col-md-6">
								<label class="form-label fw-semibold"
									>Intermediary</label
								>
								<p class="text-sm">
									{{ selectedClientQuote[0].client_names }}
								</p>
							</div>
						</div>
						<div class="mt-4 col-md-6">
							<label class="form-label fw-semibold">Status</label>
							<span>{{ selectedClientQuote[0].status }}</span>
						</div>
						<div class="mt-4">
							<label class="form-label fw-semibold text-dark"
								>Remarks</label
							>
							<p>
								{{ selectedClientQuote[0].quotation_remarks }}
							</p>
						</div>
						<div class="mt-4 d-flex justify-content-end">
							<button class="btn py-2 px-2 btn-danger">
								Reject
							</button>
						</div>
					</div>
					<div v-else class="border-bottom pb-4 mb-4">
						<p>Loading quotation details...</p>
					</div>

					<!-- Recommendations Section -->
					<div
						v-if="
							selectedClientQuote &&
							selectedClientQuote.length &&
							selectedClientQuote[0].recommendations
						"
					>
						<h2 class="h4 fw-bold mb-4">Recommendations</h2>
						<div class="container mt-5 mb-4">
							<!-- Loop through recommendations -->
							<div
								v-for="recommendation in selectedClientQuote[0]
									.recommendations"
								:key="recommendation._id"
								class="row g-3 bg-light profile-card mb-4"
							>
								<div class="col-auto">
									<img
										src="https://plus.unsplash.com/premium_photo-1678718711951-e1add4d05f59?q=80&w=3687&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
										alt="Profile"
										class="profile-img"
									/>
								</div>
								<div class="col mb-4">
									<div class="py-2">
										<label
											class="form-label fw-semibold fs-5"
											>Product</label
										>
										<p class="text-xs">
											{{
												recommendation.product &&
												recommendation.product
													.product_name
													? recommendation.product
															.product_name
													: 'N/A'
											}}
										</p>
									</div>
									<div class="py-2">
										<label
											class="form-label fw-semibold fs-5"
											>Level</label
										>
										<div class="star-rating fs-5">
											<!-- Render filled stars -->
											<i
												v-for="n in recommendation.recommendation_level"
												:key="'filled-' + n"
												class="fa-solid fa-star checked"
											></i>
											{{
												recommendation.recommendation_level
											}}
											<!-- Render empty stars -->
											<i
												v-for="n in 5 -
												recommendation.recommendation_level"
												:key="'empty-' + n"
												class="fa-solid fa-star"
											></i>
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="py-2">
										<label
											class="form-label fw-semibold fs-5"
											>Remarks</label
										>
										<p class="text-xs">
											{{
												recommendation.recommendation_remarks
											}}
										</p>
									</div>
									<div class="py-2">
										<label
											class="form-label fw-semibold fs-5"
											>Premium</label
										>
										<p class="text-xs">
											{{ recommendation.premium_amount }}
											{{
												recommendation.preferred_currency
											}}
										</p>
									</div>
								</div>
								<div class="col-md-4 d-flex flex-column gap-2">
									<button class="btn btn-success w-100 fs-6">
										Accept
									</button>
									<button
										@click="
											viewRecommendation(
												recommendation.guest_client_quotation_recommendation_ref,
											)
										"
										class="btn btn-secondary w-100 fs-6"
									>
										View
									</button>
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<p>Loading recommendations...</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import clientQuotations from '../rsc/stores/client-quotations';
import { mapGetters, mapActions } from 'vuex';

export default {
	beforeCreate() {
		console.log('beforeCreate: Component initializing');
		Event.$emit('loader:show', true);
	},
	beforeDestroy() {
		console.log('beforeDestroy: Unregistering clientQuotations module');
		this.$store.unregisterModule('clientQuotations');
	},
	created() {
		console.log('created: Registering clientQuotations module');
		try {
			utils.registerModule(
				'clientQuotations',
				clientQuotations,
				this.$store,
			);
			console.log(
				'created: Registered modules:',
				Object.keys(this.$store._modulesNamespaceMap),
			);
			console.log(
				'created: Available getters:',
				Object.keys(this.$store.getters),
			);
		} catch (error) {
			console.error(
				'created: Error registering clientQuotations module:',
				error,
			);
		}
	},
	computed: {
		...mapGetters([
			'quotationID',
			'loading',
			'clientQuotations',
			'showQuotationModal',
			'selectedClientQuote',
		]),
	},
	data() {
		console.log('data: Initializing component data');
		return {
			articles: [],
		};
	},
	methods: {
		...mapActions([
			'viewClientQuote',
			'acceptClientQuote',
			'declineClientQuote',
		]),
		viewRecommendation(id) {
			console.log(
				'viewRecommendation: Navigating to recommendation with ID:',
				id,
			);
			this.$router.push({
				name: 'ClientQuotationDetails',
				params: { id },
			});
		},
		compareRecommendation(recommendation) {
			console.log(
				'compareRecommendation: Comparing recommendation:',
				recommendation,
			);
		},
		acceptRecommendation(recommendation) {
			console.log(
				'acceptRecommendation: Accepting recommendation:',
				recommendation,
			);
		},
	},
	watch: {
		'$store.state.clientQuotations.selectedClientQuote'(newVal) {
			console.log('watch: selectedClientQuote updated:', newVal);
		},
	},
	async mounted() {
		console.log('mounted: Component mounted, fetching quote');
		console.log(
			'mounted: Initial selectedClientQuote:',
			this.$store.state.clientQuotations
				? this.$store.state.clientQuotations.selectedClientQuote
				: 'undefined',
		);
		try {
			const quotationID =
				this.quotationID || 'guest-client-quo-8d1yhhxixxmaz4x8gj';
			console.log('mounted: quotationID:', quotationID);
			if (quotationID) {
				console.log(
					'mounted: Fetching quote for quotationID:',
					quotationID,
				);
				await this.viewClientQuote(quotationID);
				console.log(
					'mounted: After viewClientQuote, selectedClientQuote:',
					this.$store.state.clientQuotations
						? this.$store.state.clientQuotations.selectedClientQuote
						: 'undefined',
				);
			} else {
				console.error('mounted: No quotationID found');
			}
		} catch (error) {
			console.error('mounted: Error fetching quote:', error);
		} finally {
			console.log('mounted: Fetch complete, hiding loader');
			Event.$emit('loader:show', false);
		}
	},
};
</script>

<style lang="less">
.profile-img {
	width: 100px;
	height: 100px;
	object-fit: cover;
	border-radius: 50%;
}
.star-rating .fa-star {
	color: #ddd;
}
.star-rating .fa-star.checked {
	color: #ffc107;
}
.profile-card {
	border-radius: 10px;
	padding: 20px;
}
</style>
